import type {
  CommissionDetails,
  CommissionPeriod,
  CommissionTransaction,
} from "@/lib/commission.api";

export function formatMoney(value: number): string {
  return `${value.toLocaleString("fr-FR")} XAF`;
}

export function formatDate(value: string): string {
  return new Date(value).toLocaleDateString("fr-FR");
}

export function isCommissionPeriod(value: unknown): value is CommissionPeriod {
  return Boolean(
    value &&
      typeof value === "object" &&
      "start" in value &&
      "end" in value &&
      typeof (value as CommissionPeriod).start === "string" &&
      typeof (value as CommissionPeriod).end === "string",
  );
}

export function formatDetailValue(value: CommissionDetails[string]): string {
  if (value === undefined || value === null || value === "") return "-";
  if (isCommissionPeriod(value)) return `${formatDate(value.start)} - ${formatDate(value.end)}`;
  if (typeof value === "number") return value.toLocaleString("fr-FR");
  return String(value);
}

export function getCommissionAmount(commission: CommissionTransaction): number {
  return parseFloat(commission.commissionAmount);
}
